import React from "react";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
    DynamicTable,
    customColumnProps,
} from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";

import { capitalize } from "../../../helpers/general";

import { store } from "../../../components/VerticalLayout/store";
import { store as storeData } from "./store";
import classnames from "classnames";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { useAuthHeader } from "../../../api/headersKeycloak";

export default function HistoryModal({ isModalOpened, setIsModalOpened }: any) {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const { selectedServices } = useSnapshot(storeData);
    const { franchiseID, userID } = useSnapshot(store);

    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [, setArrayIds] = React.useState<any[]>([]);
    const [data, setData] = React.useState<any>({});
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };

    const url = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/general/services/history?userId=${userID}&franchiseId=${franchiseID}&service=${selectedServices
        .map((el: any) => JSON.stringify(el))
        .join()}`;

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 1,
            columnName: t("Actions"),
            customJsx: (e: any) => {
                let actionsArray: any = [];
                e.selectedRow.actions.forEach((el: any) => {
                    if (el.item !== "isActive") {
                        if (el.item === "designation") {
                            actionsArray.push(t("Designation"));
                        } else if (el.item === "heure_début") {
                            actionsArray.push(t("Start time"));
                        } else if (el.item === "heure_fin") {
                            actionsArray.push(t("End time"));
                        } else if (el.item === "jour_de_la_semaine") {
                            actionsArray.push(t("Day of the week"));
                        } else if (el.item === "tag") {
                            actionsArray.push(t("Tag"));
                        }
                    }
                });
                if (e.selectedRow.operation === "modify") {
                    if (e.selectedRow?.actions[0].item === "isActive") {
                        return e.selectedRow?.actions[0].newValue === true ? (
                            <span>{t("Activation")}</span>
                        ) : (
                            <span>{t("Deactivation")}</span>
                        );
                    } else if (
                        e.selectedRow?.actions[0].item === "isArchived"
                    ) {
                        return e.selectedRow?.actions[0].newValue === true ? (
                            <span>{t("Archiving")}</span>
                        ) : (
                            <span>{t("Unarchiving")}</span>
                        );
                    }
                    return (
                        <span className="preview-text">
                            {t("Modification")}: {actionsArray.join(",")}
                        </span>
                    );
                } else if (e.selectedRow.operation === "creation") {
                    return <span>{t("Creation")}</span>;
                } else if (e.selectedRow.operation === "Affectation") {
                    return <span>{`${t("Assignment")}`}</span>;
                } else {
                    return <span>{t("Reassignment")}</span>;
                }
            },
        },
        {
            indexOFColumn: 2,
            columnName: t("Before modification"),
            customJsx: (e: any) => {
                if (e.selectedRow.operation === "modify") {
                    return (
                        <span>
                            {e.selectedRow?.actions[0]?.item ===
                            "isArchived" ? (
                                e.selectedRow?.actions[0]?.oldValue === true ? (
                                    <span>
                                        {t("Status")}: {t("Archived")}
                                    </span>
                                ) : (
                                    <span>
                                        {t("Status")}: {t("Unarchived")}
                                    </span>
                                )
                            ) : e.selectedRow.actions[0]?.item ===
                              "isActive" ? (
                                e.selectedRow.actions[0]?.oldValue === true ? (
                                    <span>
                                        {t("State")}: {t("Activated")}
                                    </span>
                                ) : (
                                    <span>
                                        {t("State")}: {t("Deactivated")}
                                    </span>
                                )
                            ) : (
                                <span className="preview-text">
                                    {e.selectedRow.actions
                                        .map((el: any) => el.oldValue)
                                        .join(",")}
                                </span>
                            )}
                        </span>
                    );
                } else if (e.selectedRow.operation === "creation") {
                    return null;
                } else if (e.selectedRow.operation === "Affectation") {
                    return <span>{""}</span>;
                } else {
                    return <span>{""}</span>;
                }
            },
        },
        {
            indexOFColumn: 3,
            columnName: t("After modification"),
            customJsx: (e: any) => {
                if (e.selectedRow.operation === "modify") {
                    return (
                        <span>
                            {e.selectedRow.actions[0].item === "isArchived" ? (
                                e.selectedRow.actions[0].newValue === true ? (
                                    <span>
                                        {t("Status")}: {t("Archived")}
                                    </span>
                                ) : (
                                    <span>
                                        {t("Status")}: {t("Unarchived")}
                                    </span>
                                )
                            ) : e.selectedRow.actions[0].item === "isActive" ? (
                                e.selectedRow.actions[0].newValue === true ? (
                                    <span>
                                        {t("State")}: {t("Activated")}
                                    </span>
                                ) : (
                                    <span>
                                        {t("State")}: {t("Deactivated")}
                                    </span>
                                )
                            ) : (
                                <span className="preview-text">
                                    {e.selectedRow.actions
                                        .map((el: any) => el.newValue)
                                        .join(",")}
                                </span>
                            )}
                        </span>
                    );
                } else if (e.selectedRow.operation === "creation") {
                    return e.selectedRow[t("Designation")] !== undefined
                        ? e.selectedRow[t("Designation")]
                        : "--";
                } else if (e.selectedRow.operation === "Affectation") {
                    return <span>{""}</span>;
                } else {
                    return <span>{""}</span>;
                }
            },
        },
    ];
    React.useEffect(() => {
        setArrayIds(selectedServices.map((el) => el.Id));
    }, [selectedServices]);

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                className="modal-wrapper__clz"
                isOpen={isModalOpened}
            >
                <ModalHeader
                    toggle={() => {
                        setIsModalOpened!(!isModalOpened);
                    }}
                    className="srv_icn_HSclose"
                >
                    <StyledH2 className="srv_txt_HStitleHistory">
                        {capitalize(t("Historical"))}
                    </StyledH2>
                </ModalHeader>

                <ModalBody>
                    <div
                        className={`${classnames("title__clz", {
                            "not-allowed-icon__clz":
                                selectedServices.length > 1,
                        })}`}
                    >
                        {t("Designation")} :{""}
                        {selectedServices.length > 1
                            ? null
                            : data?.data !== undefined
                            ? data?.data![0][t("Designation")]
                            : ""}
                    </div>
                    <DynamicTable
                        url={url}
                        canResize
                        actionColumn={ActionColumn}
                        showGlobalFilter
                        showFilter
                        setLocalFilterActive={setLocalFilterActive}
                        filterActive={filterActive}
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        setDataIsUpdated={setDataIsUpdated}
                        dataIsUpdated={dataIsUpdated}
                        elevationTable={1}
                        minHeight="500px"
                        maxHeight="500px"
                        name="historyModeOfSale"
                        arrayOfCustomColumns={arrayOfCustomColumns}
                        setData={setData}
                    />
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomMainColorButton
                        variant="primary"
                        onClick={() => {
                            setIsModalOpened(!isModalOpened);
                        }}
                        rounded
                        className="srv_btn_HSclose"
                    >
                        {t("Close")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
